import React from "react";
import T from "prop-types";
import { stringify } from "query-string";
import { toastr } from "react-redux-toastr";
import api from "APP_ROOT/api";
import { Button } from "MODULES/shared/components";
import { renderIf } from "MODULES/shared/decorators";
import { API_BASE } from "APP_ROOT/constants";
import useCurrentUser from "APP_ROOT/hooks/useCurrentUser";
import { hasRole } from "MODULES/users/helpers";
import { ADMIN, EXPORT_LIMIT } from "MODULES/users/constants";
import { SUCCESS } from "LIB/submission";

const ExportButton = ({ searchProps }) => {
  const params = searchProps.paginator.get("filters").toJS();
  const totalCount = searchProps.paginator.get("totalCount");

  params.total_count = totalCount;
  return (
    <Button
      onClick={() => {
        if (totalCount > EXPORT_LIMIT) {
          toastr.info("Processing Report.");
          api.receivingRecord.export(params).then(() => SUCCESS);
        } else {
          window.open(
            `${API_BASE}/receiving_records/export?${stringify(params)}`,
            "_blank"
          );
          toastr.success(
            "Processing Receiving Report. Please wait for the PDF to generate."
          );
        }
      }}
    >
      Export
    </Button>
  );
};

ExportButton.propTypes = {
  searchProps: T.shape({
    paginator: T.instanceOf(Map)
  })
};

const meetsExportCriteria = renderIf(({ searchProps }) => {
  const user = useCurrentUser();
  return searchProps.paginator.get("totalCount") <= 450 || hasRole(user, ADMIN);
});

const DecoratedExportButton = meetsExportCriteria(ExportButton);

export default DecoratedExportButton;



// WEBPACK FOOTER //
// ./app/modules/Receiving/Search/ExportButton.jsx